<script>
    import TokenEdit from '../../../TokenEdit.svelte';
	import CardOperations from '../../ops/CardOperations.svelte';
	import BoardBase from '../BoardBase.svelte';
    import { dbHover, dbUnhover } from '../dashfuncs';

	function makeOps(b){
		let bits = b.passives.filter(b => !b.hidden);
		let ops = [];
		for(let t of bits){
			let [type, text] = t.allText.split(':').map(b => b.trim());
			type = type.toLowerCase();
			ops.push({type, text});
		}
		return ops;
	}


	export let board;
	export let p;
	export let isPreview = false;

	let whimPositions = [
		[131, -15], [126, -8], [131, -1.5], [126, 7], [131, 14.3], [126, 21.7], [131, 29], [126, 36.5], [131, 44], [126, 51.4], [131, 58.7], [126, 66.2], [131, 73.5], [126, 81], [131, 88.4], [126, 95.8]
	]

	function getWhimPosition(whim){
		if(whim > whimPositions.length - 1) whim = whimPositions.length - 1;
		if(whim < 0 || isNaN(whim)) whim = 0;
		let pos = whimPositions[whim];
		return `top: ${pos[0]}%; left: ${pos[1]}%;`
	}
</script>

<BoardBase {p} deck="" customImage={"./assets/board-q.png"} side="advanced" hideSideLabel preview={isPreview}>
	<svelte:fragment slot="missions">
		<div class="position-override"
			on:mouseenter={e => {dbHover(e, p, isPreview, 'all')}}
			on:mousemove={e => {dbHover(e, p, isPreview, 'all')}}
			on:mouseleave={e => {dbUnhover(e, p)}} 
		>
			<div class="info-container mission">
				<CardOperations operations={makeOps(board)} />
			</div>
			<div class="tokens">
				<TokenEdit card={true} p={board.passives[0]} r="dilithium" size={3} hideIfEmpty={true}/>  
			</div>
		</div>
		<div class="marker" style={getWhimPosition(p.whim || 0)}></div>
		<!--<div class="marker limit" style={getWhimPosition((p.whim_limit || 0) + 1)}></div>-->
	</svelte:fragment>
</BoardBase>

<style lang="scss">
	.position-override {
		position: relative;
		width: 100%;
		height: 100%;
		left: 10%;
	}
	.info-container {
		position: absolute;
		top: 2%;
		left: 13%;
		display: flex;
		flex-direction: row;
		gap: 10px;
		width: 81%;
		height: fit-content;
		scale: 1.02;
	}

	.tokens {
		position: aboslute;
		top: -5%;
		left: -9%;
		color: white;
	}

	.marker {
		position: absolute;
		width: calc(var(--height) / 11);
    	height: calc(var(--height) / 11);
		outline: 2px solid white;
		transition: left 0.5s, top 0.5s;
		background-color: pink;
	}

	.limit {
		background-color: yellow;
	}
	
</style>
